import Component from '../../js/_Component';

export default class BoatTitleLockup extends Component {

}

Component.register(BoatTitleLockup, 'BoatTitleLockup');
